import $ from 'jquery';
import 'bootstrap';
// import 'animate.css';
import AOS from 'aos';
import CookieControl from '@netgen/javascript-cookie-control';

const general = {
    handleCookieBar: function() {
        const ccConfig = {
            options: {
                lifetime: 30,
                optionCookieHtml: cookie => `
                <li>
                   <div class="custom-control custom-checkbox">
                       <input type="checkbox" class="custom-control-input ng-cc-optional-checkbox" id="ng-cc-${cookie.name}" data-name="${cookie.name}" ${cookie.accepted ? 'checked' : ''} >
                       <label class="custom-control-label" for="ng-cc-${cookie.name}">${cookie.label ? cookie.label : ''}</label>
                   </div>
                   ${cookie.description ? `<p>${cookie.description}</p>` : ''}
                </li>`,
            },
            optionalCookies: [
                {
                    name: 'analytics',
                    label: 'Cookies analytiques',
                    description: 'Les cookies analytiques nous aident à améliorer notre site web en collectant et en rapportant des informations sur son utilisation.',
                    accepted: true,
                    onAccept() {
                        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','GTM-5SPN3GM');
                    },
                },
            ],
        };

        // create new cookie control instance
        const cookieControl = new CookieControl(ccConfig);
        // initialize the plugin
        cookieControl.init();
    }
}

import Rellax from 'rellax/rellax.min';
export default general;

(function($){
    $(document).ready(function(){
        AOS.init();
        var rellax = new Rellax('.rellax');
        general.handleCookieBar();
    });
})($);
